import { render, staticRenderFns } from "./Messenger.vue?vue&type=template&id=19b4a8a1&lang=pug"
import script from "./Messenger.vue?vue&type=script&lang=js"
export * from "./Messenger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports